import React, { useEffect, useState } from "react";
import HelmetWrapper from "../../HelmetWrapper";
import { Button, Col, Container, Row } from "react-bootstrap";
import Modal from "react-modal";
import TvNotificationUpdate from "./tvNotificationUpdate";
import { fetchTvStakeHolderData } from "../../redux/reducers/apiSlice";
import { selectAuth } from "../auth/auth.selector";
import { useDispatch, useSelector } from "react-redux";
import { DeleteIcon, EditIcon } from "../../images/icons/website-icons";
import Loader from "../ui/Loader";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import moment from "moment";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { toast } from "react-toastify";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";
import {
  additionalStakeholderDelete,
  tvStakeholderDelete,
} from "../../data/ApiEndpoints";
import { Tab, TabList, Tabs } from "react-tabs";
import TvUserTaggingUpdate from "./tvUserTaggingUpdate";
import {
  commonPostPutApi,
  fetchApiData,
} from "../../redux/reducers/commonApiSlice";
import SelectDropdownLabel from "../components-react/SelectDropdownLabel";
import { formatTime, stakeholderOptions } from "./tv-utils";
import CommonStructured from "../common-components/CommonStructured";

const TvNotification = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const {
    data: usersData,
    loading: usersLoading,
    error: usersError,
  } = useSelector((state) => state.common);
  const { TVStakeHolderData, loading: TVStakeHolderLoading } = useSelector(
    (state) => state.api
  );

  const isAdmin = userInfoData?.account_type === "admin";

  const [initialValue, setInitialValue] = useState(null);
  const [isPage, setIsPage] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [pageLimit, setPageLimit] = useState(10);
  const [isRoleWise, setIsRoleWise] = useState(true);

  const handleAdd = (isRoleWise) => {
    setIsRoleWise(isRoleWise);
    setIsEdit(false);
    setModalOpen(true);
    setInitialValue(null);
  };

  const handleEdit = (row) => {
    setIsEdit(true);
    setModalOpen(true);
    setInitialValue(row);
  };

  function onCloseModalvalues() {
    setModalOpen(false);
  }

  const initialFilter = {
    search: "",
    status: "",
    limit: pageLimit,
    page: isPage + 1,
    start_date: "",
    end_date: "",
    date: "",
  };

  const [filters, setFilters] = useState(initialFilter);

  const stakeholderInitialFilter = {
    tv_stakeholder_type: "",
    user_id: "",
  };

  const [stakeholderFilter, setStakeholderFilter] = useState(
    stakeholderInitialFilter
  );

  const payload = {
    filters: filters,
    token: userInfoData?.token,
  };

  const fetchUsersData = () => {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: "/user",
        payload: {
          filters: {
            is_tv_stakeholder: 1,
            tv_stakeholder_type:
              stakeholderFilter?.tv_stakeholder_type?.value || "",
            uid: stakeholderFilter?.user_id?.value || "",
          },
        },
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    fetchUsersData();
  }, [userInfoData?.gym_id, stakeholderFilter]);

  const getTvStakeHolderData = () => {
    dispatch(fetchTvStakeHolderData(payload));
  };

  useEffect(() => {
    getTvStakeHolderData();
  }, [userInfoData?.gym_id, filters]);

  const handleReset = () => {
    setFilters(initialFilter);
    setStakeholderFilter(stakeholderInitialFilter);
  };

  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      page: isPage + 1,
      limit: pageLimit,
    }));
  }, [pageLimit, isPage]);

  const handleDelete = async (type, filter) => {
    let response;
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          if (type === "tv") {
            response = await dispatch(
              commonDeleteApi({
                TOKEN: userInfoData?.token,
                endpoint: tvStakeholderDelete,
                queryParams: filter,
              })
            ).unwrap();
          } else {
            response = await dispatch(
              commonPostPutApi({
                method: "POST",
                endpoint: `${additionalStakeholderDelete}?user_id=${filter?.uid}`,
                token: userInfoData?.token,
                payload: {},
              })
            ).unwrap();
          }

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            getTvStakeHolderData();
            fetchUsersData();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  const handleEditUser = (row, isRoleWise) => {
    setIsEdit(true);
    setModalOpen(true);
    setInitialValue(row);
    setIsRoleWise(isRoleWise);
  };

  const tbColumns = [
    {
      dataField: "notification_role",
      text: "Notification Role",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.notification_role || "NA"}
          </span>
        );
      },
    },

    {
      dataField: "time_from",
      text: "Notification(Time From)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.time_from ? formatTime(row?.time_from) : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "time_to",
      text: "Notification(Time To)",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.time_to ? formatTime(row?.time_to) : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "last_updated",
      text: "last updated",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.last_updated
              ? moment(row.last_updated)?.format("DD-MM-YYYY")
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added
              ? moment(row.date_added)?.format("DD-MM-YYYY")
              : "-"}
          </span>
        );
      },
    },

    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() => handleEdit(row)}
          >
            <EditIcon />
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete("tv", uidFilter);
            }}
          >
            {usersLoading || TVStakeHolderLoading ? <Loader /> : <DeleteIcon />}
          </button>
        </div>
      ),
    },
  ];

  const userColumns = [
    {
      dataField: "user_details",
      text: "User Details",
      formatter: (name, row) => {
        return (
          <span className="tb-data">
            {row?.name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "account_type",
      text: "Account Type",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.account_type || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "tv_stakeholder_type",
      text: "TV StakeHolder Type",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.tv_stakeholder_type || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() => handleEditUser(row, false)}
          >
            <EditIcon />
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete("stakeholder", uidFilter);
            }}
          >
            <DeleteIcon />
          </button>
        </div>
      ),
    },
  ];

  const userOptions = usersData?.data?.map((user) => ({
    label: user?.name,
    value: user?.uid,
  }));

  return (
    <HelmetWrapper title="WTF: TV Notifications StakeHolders">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <CommonStructured
              pageHeading={"TV Notifications StakeHolders"}
              createBtnTxt={isAdmin ? "+ Add Role Wise" : null}
              onClickCreateBtn={() => handleAdd(true)}
              createBtnTxt1={isAdmin ? "+ Add Additional StakeHolders" : null}
              onClickCreateBtn1={() => handleAdd(false)}
              isReload={() => {
                getTvStakeHolderData();
                fetchUsersData();
              }}
            />
          </Col>
        </Row>

        <div>
          <Modal
            isOpen={modalOpen}
            onRequestClose={onCloseModalvalues}
            contentLabel="Career Modal"
            ariaHideApp={false}
          >
            {isRoleWise ? (
              <TvNotificationUpdate
                callFunction={getTvStakeHolderData}
                isEdit={isEdit}
                closeModal={onCloseModalvalues}
                initialValues={initialValue}
                token={userInfoData?.token}
                isRoleWise={isRoleWise}
              />
            ) : (
              <TvUserTaggingUpdate
                callFunction={fetchUsersData}
                isEdit={isEdit}
                closeModal={onCloseModalvalues}
                initialValues={initialValue}
                token={userInfoData?.token}
                isRoleWise={isRoleWise}
              />
            )}
          </Modal>
          <div className="pt-2 d-flex justify-content-start align-items-center">
            <div className="agentTabWrapper">
              <Tabs>
                <TabList className="agentTabListWrapper">
                  <Tab
                    className="customTab"
                    onClick={() => setIsRoleWise(true)}
                  >
                    <span>Role Wise</span>
                  </Tab>
                  <Tab
                    className="customTab "
                    onClick={() => setIsRoleWise(false)}
                  >
                    <span>Additional StakeHolders</span>
                  </Tab>
                </TabList>
              </Tabs>
            </div>
          </div>
          {!isRoleWise && (
            <div className="cmnFilterStructureContainer ptTrackContainer">
              <div className="filterblock gridSpanTwo">
                <div className="filterHeadingNBtn">
                  <h5 className="filterHeading">All Filters</h5>
                  <Button variant="outline-danger" onClick={handleReset}>
                    Reset Filter
                  </Button>
                </div>

                <div className="filterblock grid__three">
                  {!isRoleWise ? (
                    <>
                      <div className={`commonWrapper dropdownCommonWrapper `}>
                        <SelectDropdownLabel
                          options={userOptions}
                          value={stakeholderFilter.user_id}
                          setSelectedOption={(selectedOption) =>
                            setStakeholderFilter((prevFilters) => ({
                              ...prevFilters,
                              user_id: selectedOption,
                            }))
                          }
                          name="Select User"
                        />
                      </div>
                      <div className={`commonWrapper dropdownCommonWrapper `}>
                        <SelectDropdownLabel
                          options={stakeholderOptions}
                          value={stakeholderFilter.tv_stakeholder_type}
                          setSelectedOption={(selectedOption) =>
                            setStakeholderFilter((prevFilters) => ({
                              ...prevFilters,
                              tv_stakeholder_type: selectedOption,
                            }))
                          }
                          name="Select TV StakeHolder Type"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {/* <div
                    className={`closure-date-picker commonWrapper commonWrapper dropdownCommonWrapper `}
                  >
                    <input
                      type="date"
                      className={`${
                        filters.followup_date ? "date-has-value" : ""
                      }`}
                      value={filters.followup_date}
                      onChange={handleChangeDate}
                    />
                  </div> */}
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt-3">
            {usersLoading || TVStakeHolderLoading ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={
                  isRoleWise
                    ? TVStakeHolderData?.data?.length > 0
                      ? TVStakeHolderData?.data
                      : []
                    : usersData?.data?.length > 0
                    ? usersData?.data
                    : []
                }
                tableColumns={isRoleWise ? tbColumns : userColumns}
                tablePagination={
                  isRoleWise
                    ? TVStakeHolderData?.pagination?.length > 0
                      ? TVStakeHolderData?.pagination
                      : []
                    : usersData?.pagination?.length > 0
                    ? usersData?.pagination
                    : []
                }
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={(value) => setPageLimit(value)}
              />
            )}
          </div>{" "}
        </div>
      </Container>
    </HelmetWrapper>
  );
};

export default TvNotification;
